import React, { FC } from 'react'
import { StyleSheetManager, ThemeProvider as SThemeProvider } from 'styled-components'
import isPropValid from '@emotion/is-prop-valid'

import { theme } from '../../../lib/theme'

// This implements the default behavior from styled-components v5
function shouldForwardProp(propName: string, target: unknown) {
    if (typeof target === 'string') {
        // For HTML elements, forward the prop if it is a valid HTML attribute
        return isPropValid(propName)
    }
    // For other elements, forward all props
    return true
}
type ThemeProviderProps = {
    children: React.ReactNode
}

export const ThemeProvider: FC<ThemeProviderProps> = ({ children }) => {
    // disable CSSOM injection to fix Chromium styling issue https://issues.chromium.org/issues/379758212
    return (
        <StyleSheetManager shouldForwardProp={shouldForwardProp} disableCSSOMInjection>
            <SThemeProvider theme={theme}>{children}</SThemeProvider>
        </StyleSheetManager>
    )
}
